import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fonzi',
  templateUrl: './fonzi.component.html',
  styleUrls: ['./fonzi.component.scss']
})
export class FonziComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/fonzi.component.ts